<template>
    <modal
        size="lg"
        class="text-left dm-modal"
        id="dm-report-issues-modal"
        :title="translate('Report an Issue')"
    >
        <IssuesForm
            :key="'issues-form-' + formKey"
            @formSubmitted="formKey++"
        />
    </modal>
</template>

<script>
import IssuesForm from "../IssuesForm.vue";

export default {
    data() {
        return {
            formKey: 1,
        };
    },

    components: { IssuesForm },

    methods: {
        initializeRegularDomWatcher() {
            $(document).on("click", ".dm-report-issue-button", function () {
                jQuery("#dm-report-issues-modal").modal();
            });
        },
    },

    mounted() {
        this.initializeRegularDomWatcher();
    },
};
</script>
